// extracted by mini-css-extract-plugin
module.exports = {"timeline":"Timeline_timeline__1sjPj"};